// import { createConfirmation } from 'react-confirm';
// import YourDialog from './YourDialog';

// // create confirm function
// export const confirm = createConfirmation(YourDialog);

// // This is optional. But wrapping function makes it easy to use.
// export function confirmWrapper(confirmation : string, options = {}) {
//   return confirm({ confirmation, options });
// }

import { createConfirmation } from "react-confirm";
import YourDialog from "./YourDialog";

export const confirm = createConfirmation<any, any>(YourDialog);

export function confirmWrapper(confirmation: string, options = {}) {
  return confirm({ confirmation, options });
}